import { updateLocale, useLanguageChange } from '@repo-level/core-front';
import { Select } from 'components/form/Select';
import { Locale } from 'languages';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { optionsLanguages } from './helpers';

import { ScLanguageSwitcher } from './styled';

type AvailableLocales = Exclude<
  Locale,
  Locale.SLOVENIAN | Locale.NORWEGIAN | Locale.FRENCH_SWITZERLAND
>;

const LocaleRecord: Record<AvailableLocales, Locale> = {
  [Locale.ENGLISH]: Locale.ENGLISH,
  [Locale.ENGLISH_NEW_ZEALAND]: Locale.ENGLISH_NEW_ZEALAND,
  [Locale.ENGLISH_AUSTRALIA]: Locale.ENGLISH_AUSTRALIA,
  [Locale.ENGLISH_CANADA]: Locale.ENGLISH_CANADA,
  [Locale.FRENCH_CANADA]: Locale.FRENCH_CANADA,
  [Locale.FRENCH]: Locale.FRENCH_SWITZERLAND,
  [Locale.GERMAN]: Locale.GERMAN,
  [Locale.IRISH]: Locale.IRISH,
};

export const LanguageSwitcher = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const [handleChangeLanguage] = useLanguageChange();

  const changeLanguage = useCallback(
    (lng: AvailableLocales) => {
      handleChangeLanguage(lng);
      try {
        updateLocale({ locale: LocaleRecord[lng] });
      } catch {
        console.error('Error updating locale');
      }
    },
    [handleChangeLanguage]
  );

  return (
    <ScLanguageSwitcher>
      <Select
        field="language"
        initialValue={language}
        key={language}
        lightBg
        lightColoredDropMode
        maxHeight={268}
        onSelect={(lang: any) => {
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 200);
          void changeLanguage(lang);
        }}
        options={optionsLanguages}
        placeholder={t('glossary:region')}
        up
        withBorderArrow
      />
    </ScLanguageSwitcher>
  );
};
